(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-ui/input-range/assets/javascripts/input-range.js') >= 0) return;  svs.modules.push('/components/lb-ui/input-range/assets/javascripts/input-range.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  useCallback,
  useEffect,
  useRef,
  useState
} = React;
const {
  InputRangeHandle,
  InputRangeTrackFill
} = svs.components.lbUi.inputRange;
const InputRange = _ref => {
  let {
    hasIcons,
    maxCap,
    minCap,
    offsetRange,
    onChange,
    selectedMax,
    selectedMin
  } = _ref;
  const [state, setState] = useState({
    active: false,
    rangeSliderWidth: 0,
    percentageA: 0,
    percentageB: 0
  });
  const refRange = useRef(null);
  const init = useRef(false);
  const busy = useRef(false);
  const previous = useRef({
    selectedMin: 0,
    selectedMax: 0
  });

  const currentNumericSelections = useCallback(_ref2 => {
    let {
      percentageA,
      percentageB
    } = _ref2;
    const [start, stop] = [percentageA, percentageB].sort((a, b) => a - b);
    const selectedLowest = Math.round(start * (maxCap - minCap) + minCap);
    const selectedHighest = Math.round(stop * (maxCap - minCap) + minCap);
    return [selectedLowest, selectedHighest];
  }, [maxCap, minCap]);

  const currentExpectedPercentages = useCallback(() => {
    const {
      percentageA,
      percentageB
    } = state;
    const lowestPercentage = (selectedMin - minCap) / (maxCap - minCap);
    const highestPercentage = (selectedMax - minCap) / (maxCap - minCap);
    const sorted = [lowestPercentage, highestPercentage].sort((a, b) => percentageA <= percentageB ? a - b : b - a);
    return sorted.map(v => Math.max(0, Math.min(1, v)));
  }, [maxCap, minCap, selectedMax, selectedMin, state]);
  const setPercentagesAccordingToProps = useCallback(() => {
    const {
      percentageA: currentA,
      percentageB: currentB
    } = state;
    const [currentLowest, currentHighest] = currentNumericSelections({
      percentageA: currentA,
      percentageB: currentB
    });
    const [percentageA, percentageB] = currentExpectedPercentages();
    if (selectedMin !== currentLowest && selectedMin !== currentHighest || selectedMax !== currentLowest && selectedMax !== currentHighest) {
      setState(prevState => ({
        active: prevState.active,
        rangeSliderWidth: prevState.rangeSliderWidth,
        percentageA: selectedMin < minCap || selectedMax < minCap ? 0 : percentageA,
        percentageB: selectedMax > maxCap || selectedMax > maxCap ? 1 : percentageB
      }));
    }
  }, [currentExpectedPercentages, currentNumericSelections, maxCap, minCap, selectedMax, selectedMin, state]);
  const onHandleChange = (name, position, offset) => {
    const {
      percentageA,
      percentageB
    } = state;
    const newPercentage = position / (state.rangeSliderWidth + offset);
    const clamped = Math.min(1, Math.max(0, newPercentage));
    const [currentLowest, currentHighest] = currentNumericSelections({
      percentageA,
      percentageB,
      [name]: clamped
    });
    if (Number(selectedMin) !== Number(currentLowest) || Number(selectedMax) !== Number(currentHighest)) {
      if (!busy.current) {
        busy.current = true;
        requestAnimationFrame(() => {
          busy.current = false;
          onChange({
            selectedMin: currentLowest,
            selectedMax: currentHighest
          });
        });
      }
    }
  };
  const handleLeftHandleChange = position => onHandleChange('percentageA', position, offsetRange);
  const handleRightHandleChange = position => onHandleChange('percentageB', position, offsetRange);
  const handleResize = useCallback(() => setState(prevState => _objectSpread(_objectSpread({}, prevState), {}, {
    active: false,
    rangeSliderWidth: refRange.current.offsetWidth
  })), [refRange]);
  const handleTouchEnd = () => {
    window.removeEventListener('mouseup', handleTouchEnd);
    setState(prevState => _objectSpread(_objectSpread({}, prevState), {}, {
      active: false
    }));
  };
  const handleTouchStart = () => {
    if (svs.core.detect.formfactor.desktop()) {
      window.addEventListener('mouseup', handleTouchEnd);
    }
    setState(prevState => _objectSpread(_objectSpread({}, prevState), {}, {
      active: true
    }));
  };
  const [start, stop] = [state.percentageA, state.percentageB].sort((a, b) => a - b);
  useEffect(() => {
    if (!init.current) {
      init.current = true;
      handleResize();
      setPercentagesAccordingToProps();
    }
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [handleResize, setPercentagesAccordingToProps]);
  useEffect(() => {
    if (selectedMin !== previous.current.selectedMin || selectedMax !== previous.current.selectedMax) {
      setPercentagesAccordingToProps();
      previous.current = _objectSpread(_objectSpread({}, previous.current), {}, {
        selectedMin,
        selectedMax
      });
    }
  }, [selectedMax, selectedMin, setPercentagesAccordingToProps]);
  return React.createElement("div", {
    className: "input-range-outer",
    "data-testid": "qa-input-range"
  }, React.createElement("div", {
    className: "input-range".concat(state.active ? ' input-range-is-active' : ''),
    onMouseDown: handleTouchStart,
    onTouchEnd: handleTouchEnd,
    onTouchStart: handleTouchStart,
    ref: refRange
  }, React.createElement(InputRangeTrackFill, {
    scale: stop - start,
    startPos: start * state.rangeSliderWidth
  }), React.createElement(InputRangeHandle, {
    className: "input-range-btn input-range-btn-min",
    hasIcons: hasIcons,
    offset: state.percentageA * (state.rangeSliderWidth + offsetRange),
    onChange: handleLeftHandleChange
  }), React.createElement(InputRangeHandle, {
    className: "input-range-btn input-range-btn-max",
    hasIcons: hasIcons,
    offset: state.percentageB * (state.rangeSliderWidth + offsetRange),
    onChange: handleRightHandleChange
  })));
};
InputRange.defaultProps = {
  hasIcons: true,
  offsetRange: 0
};
setGlobal('svs.components.lbUi.inputRange.InputRange', InputRange);

 })(window);